"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transientService = exports.TransientServiceHolder = void 0;
var instantiation_1 = require("./instantiation");
var instantiation_hook_1 = require("./instantiation-hook");
/**
 * 用于包裹非单例模块
 */
var TransientServiceHolder = /** @class */ (function () {
    function TransientServiceHolder(params, instantiationService) {
        if (params === void 0) { params = []; }
        this.instantiationService = instantiationService;
        this.instantiationHook = new instantiation_hook_1.InstantiationHook();
        this.params = params;
    }
    /**
     * 获取模块实例时支持传递参数
     * @param params
     */
    TransientServiceHolder.prototype.getNewInstance = function (params) {
        var _a;
        var allParams = params || (this.params.length > 0 ? this.params : []);
        var ctor = this.getCtor();
        var instance = (_a = this.instantiationService).createInstance.apply(_a, __spread([ctor], allParams));
        this.executeHooks(instance, instantiation_1.IInstantiationHookPoint.POST_CONSTRUCTOR);
        return instance;
    };
    TransientServiceHolder.prototype.addHook = function (hookPoint, callback) {
        this.instantiationHook.addHook(hookPoint, callback);
    };
    TransientServiceHolder.prototype.executeHooks = function (instance, point) {
        this.instantiationHook.executeHooks(instance, point);
    };
    TransientServiceHolder = __decorate([
        __param(1, instantiation_1.IInstantiationService)
    ], TransientServiceHolder);
    return TransientServiceHolder;
}());
exports.TransientServiceHolder = TransientServiceHolder;
/**
 * 提供一个helper函数，将普通构造函数包装成非单例模块Holder
 * @param ctor
 */
function transientService(ctor) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.getCtor = function () {
            return ctor;
        };
        return class_1;
    }(TransientServiceHolder));
}
exports.transientService = transientService;
//# sourceMappingURL=transient-service.js.map